/* eslint-disable */
import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { EPaymentTab } from 'common/const';
import { IOrganization } from 'common/types/organization.types';
import { IUser } from 'common/types/user.types';

export interface IGlobalContext {
  organization: IOrganization | null;
  setOrganization: (value: IOrganization) => void;
  user: IUser | null;
  setUser: (value: IUser | null) => void;
  activeTab: EPaymentTab;
  setActiveTab: (value: EPaymentTab) => void;
  /** true только для первого экрана воронки в этой загрузке страницы: переходы внутри страницы
   *  (в том числе «назад» на список) входом не бывают (metrika-landing, R-3). */
  claimFirstScreen: () => boolean;
}

const GlobalContext = createContext<IGlobalContext>({
  organization: null,
  setOrganization: () => {},
  user: null,
  setUser: () => {},
  activeTab: EPaymentTab.Tips,
  setActiveTab: () => {},
  claimFirstScreen: () => false,
});

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }: { children: React.ReactNode }) => {
  const [organization, setOrganization] = useState<IOrganization | null>(null);
  const [user, setUser] = useState<IUser | null>(null);
  const [activeTab, setActiveTab] = useState<EPaymentTab>(EPaymentTab.Tips);
  const firstScreenRef = useRef<boolean>(true);

  const claimFirstScreen = useCallback(() => {
    const first = firstScreenRef.current;

    firstScreenRef.current = false;
    return first;
  }, []);

  return (
    <GlobalContext.Provider value={{ organization, setOrganization, user, setUser, activeTab, setActiveTab, claimFirstScreen }}>
      {children}
    </GlobalContext.Provider>
  );
};
